// 不同平台参数
export default {
  bigo: {
    name: 'bigo',
    logoImg: require('~/assets/js/player/assets/img/bigologo.png'), // 图标
    appId: '953097631439235', // appid
    host: 'www.bigolive.tv', // 接口host
    wsHost: 'bigolive.tv', // wshost
    router: '/studio', // 接口路由
    wss: '/studio/getWebSocketLink', // 请求wsslinkd
    wss2: '/studio/getWebSocketLink2' // wsslinkd兜底方案
  },
  cube: {
    name: 'cube',
    logoImg: require('~/assets/js/player/assets/img/cubelogo.png'),
    appId: '485991825143648',
    host: 'www.cube.tv',
    wsHost: 'cube.tv',
    router: '/studioApi',
    wss: '/login/getAnonymousWssServer'
  }
};
